import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PublicIcon from '@mui/icons-material/Public';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BlockIcon from '@mui/icons-material/Block';
import { formatExpiryDate, isPastDate, isToday } from 'utils/dateUtils';
import { toInt } from 'utils/numberUtils';
('utils/numberUtils');
import './ClientCard.css';

const ClientCard = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [card, setCard] = useState({});
  const [hasNewComent, setHasNewComent] = useState(false);

  useEffect(() => {
    setCard(props.card);
    setHasNewComent(props.newCommentIds.has(toInt(props.card.CARD_ID)));
  }, [props.lists]);

  // 設定画面呼び出しボタン
  const handleClickEdit = (e) => {
    e.preventDefault();
    props.callEditModal(card);
  };

  // 期限のクリック処理
  const handleClickExpiry = () => {
    props.updateCompleteCard({
      CARD_ID: card.CARD_ID,
      COMPLETE_FLG: card.COMPLETE_FLG ? 0 : 1,
    });
    setCard({ ...card, COMPLETE_FLG: card.COMPLETE_FLG ? 0 : 1 });
  };

  // 年間更新チェック処理
  const handleClickYmCheck = () => {
    props.updateYmCheck({
      CARD_ID: card.CARD_ID,
      YM_CHECK_FLG: card.YM_CHECK_FLG ? 0 : 1,
    });
    setCard({ ...card, YM_CHECK_FLG: card.YM_CHECK_FLG ? 0 : 1 });
  };

  // マウスオーバー時の処理
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  // マウスアウト時の処理
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className="card"
      {...props.provided.draggableProps}
      {...props.provided.dragHandleProps}
      ref={props.provided.innerRef}
      onDoubleClick={handleClickEdit}
    >
      {card.TITLE}
      <a href="#" className="avatar-container" onClick={handleClickEdit}>
        <Avatar sx={{ width: 24, height: 24 }}>
          <i className="material-symbols-rounded" style={{ fontSize: 16 }}>
            mode_edit
          </i>
        </Avatar>
      </a>

      <div className="expiry-comment">
        {/* 年間更新間近アイコン */}
        {card.YEAR_MANAGE_INFO === '年間更新間近' && (
          <div
            className={card.YM_CHECK_FLG ? 'year-manage-checked-icon' : 'year-manage-limit-icon'}
            style={{ cursor: 'pointer' }}
            onClick={handleClickYmCheck}
          >
            <AutorenewIcon fontSize="small" />
            年間更新時期
          </div>
        )}
        {/* 新着アイコン */}
        {hasNewComent && (
          <div className="newcomment-icon">
            <NotificationsActiveIcon fontSize="small" />
            New
          </div>
        )}
        {card.PUBLIC_INFO &&
          (card.PUBLIC_INFO === '公開期限間近' ? (
            <div className="shared-public-limit-icon">
              <WarningAmberIcon fontSize="small" />
              公開期限間近！
            </div>
          ) : card.PUBLIC_INFO === '公開終了' ? (
            <div className="shared-public-end-icon">
              <BlockIcon fontSize="small" />
              公開終了
            </div>
          ) : (
            <div className="shared-public-icon">
              <PublicIcon fontSize="small" />
              公開中
            </div>
          ))}
        {card.EXPIRY && (
          <>
            <div
              className={`expiry ${
                card.COMPLETE_FLG
                  ? 'complete'
                  : isToday(card.EXPIRY)
                    ? 'deadline'
                    : isPastDate(card.EXPIRY)
                      ? 'overdue'
                      : ''
              }`}
              onClick={handleClickExpiry}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer' }}
            >
              {isHovered ? (
                card.COMPLETE_FLG === 0 ? (
                  <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />
                ) : (
                  <CheckBoxOutlinedIcon fontSize="small" />
                )
              ) : (
                <AccessTimeIcon fontSize="small" />
              )}
              <span
                style={{
                  marginLeft: '6px',
                  fontSize: '10pt',
                }}
              >
                {formatExpiryDate(card.EXPIRY)}
              </span>
            </div>
          </>
        )}
        {card.COMMENT_COUNT > 0 && (
          <div>
            <ChatBubbleOutlineIcon fontSize="small" />
            <span
              style={{
                marginLeft: '6px',
                fontSize: '10pt',
              }}
            >
              {card.COMMENT_COUNT}
            </span>
          </div>
        )}
        {card.QUOTE_COUNT > 0 && (
          <div>
            <DescriptionOutlinedIcon fontSize="small" />
            <span
              style={{
                marginLeft: '6px',
                fontSize: '10pt',
              }}
            >
              {card.QUOTE_COUNT}
            </span>
          </div>
        )}
        {card.CONTRACT_COUNT > 0 && (
          <div>
            <HandshakeOutlinedIcon fontSize="small" />
            <span
              style={{
                marginLeft: '6px',
                fontSize: '10pt',
              }}
            >
              {card.CONTRACT_COUNT}
            </span>
          </div>
        )}
        {card.WARRANTY_RELEASE_FLG === 1 && (
          <div
            className={
              card.WARRANTY_RELEASE_DATE
                ? 'warranty-issued-icon'
                : 'warranty-unissued-icon'
            }
          >
            保証書{card.WARRANTY_RELEASE_DATE && '済'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientCard;
